import { updateData } from '../functions/firebaseFunctions'

const tags = {
    node: {
        color: '#84ba64',
        name: 'Node.js'
    },
    php: {
        color: '#7A86B8',
        name: 'php',
    },
    js: {
        color: '#FCDC00',
        name: 'JavaSctipt'
    },
    firebase: {
        color: '#ffcc2f',
        name: 'Firebase'
    },
    react: {
        color: '#61dafb',
        name: 'React'
    },
    rn: {
        color: '#61dafb',
        name: 'React Native'
    },
    html: {
        color: '#ff6739e6',
        name: "HTML"
    },
    css: {
        color: '#2965f1',
        name: "CSS"
    },
    stripe: {
        color: '#837bff',
        name: "Stripe"
    },
    c: {
        color: '#7C8BC0',
        name: 'C'
    },
    eng: {
        color: '#FFFFFF',
        name: 'English'
    },
    rus: {
        color: '#F4484C',
        name: 'Russian'
    },
    ms: {
        name: "MS Office",
        color: '#FF6520'
    },
    fusion: {
        name: "Fusion 360",
        color: '#FF7F50'
    },
    eagle: {
        name: "Eagle",
        color: "#FF8C00"
    },
    ltspice: {
        name: "LTSpice",
        color: "#FC446C"
    },
    d3: {
        name: "3D Modeling",
        color: '#FF8C00'
    },
    circuit: {
        name: 'Circuit Design',
        color: '#FC446C'
    },
    prog: {
        name: 'Programming',
        color: '#61dafb'
    },
    bgames: {
        name: 'Board Games',
        color: '#EA85F3'
    },
    biking: {
        name: 'Biking',
        color: '#90EE90'
    },
    uk: {
        name: 'Ukulele',
        color: '#F0E68C'
    },
    arduino: {
        name: 'Arduino',
        color: '#30C7Cd'
    },
    pic: {
        name: 'PIC',
        color: '#ff3030'
    },
    graph: {
        name: 'Graphic Design',
        color: '#9ACD32'
    },
    vhdl: {
        name: 'VHDL',
        color: '#20B2AA'
    },
}

export default function Tag({ tag, selectedTags, setSelectedTags, user, projectId }) {
    const outerStyle = {
        color: tags[tag]?.color || 'white',
        fontSize: 14,
        backgroundColor: 'var(--mdGray)',
        borderRadius: 12,
        borderWidth: 0,
        display: 'flex',
        alignItems: 'center',
        height: 20,
        width: 'fit-content',
        paddingRight: 10,
    }
    const tagsArray = Object.entries(tags).map(([key, value]) => ({
        key,
        ...value,
    }));
    const path = `projects/${projectId}/tags`
    let filteredTags = tagsArray;
    if (selectedTags) { // if there are selected tags then filter them out from the options
        filteredTags = tagsArray.filter(entry => !selectedTags.includes(entry.key))
    }
    const handleSelect = (select) => {
        const newTags = [...selectedTags, select.target.value,]; // append the new value to the tags array
        setSelectedTags(newTags); // update the array in the parrent
        select.target.value = ''; // reset the add tag to the default option
        updateData(path, newTags) // update the tags in the database
    }
    const handleDelete = () => {
        const newTags = selectedTags.filter(taG => taG !== tag); // remove the tag from the array
        setSelectedTags(newTags); // update the array in the parrent
        updateData(path, newTags) // update the tags in the database
    }
    return (
        <li style={{
            marginBlockEnd: 5,
            listStyleType: 'none',
            marginRight: 5
        }}>
            {user ?
                <button style={outerStyle} className="popUp del"
                    onClick={handleDelete}>
                    <div style={{
                        backgroundColor: tags[tag]?.color || 'white',
                        borderRadius: '50%',
                        height: 8,
                        width: 8,
                        margin: "6px"
                    }} />
                    {tags[tag].name}
                </button>
                :
                <div style={outerStyle} className={tag === "add" ? "popUp" : undefined}>
                    <div style={{
                        backgroundColor: tags[tag]?.color || 'white',
                        borderRadius: '50%',
                        height: 8,
                        width: 8,
                        margin: "6px"
                    }} />
                    {tag === "add" ?
                        <select style={{
                            cursor: "inherit",
                            color: 'white',
                            backgroundColor: 'transparent',
                            borderWidth: 0,
                            height: 20,
                        }} name="tags" id="tag-select" onChange={handleSelect} defaultValue={""}>
                            <option style={{ textAlign: 'center', display: 'none' }} disabled value="">Add +</option>
                            {filteredTags?.map(Atag =>
                                <option
                                    style={{
                                        textAlign: 'center',
                                        color: Atag.color,
                                        backgroundColor: 'var(--mdGray)',
                                        lineHeight: 2
                                    }}
                                    key={Atag.key}
                                    value={Atag.key}
                                >{Atag.name}</option>)}
                        </select> :
                        tags[tag].name
                    }
                </div>
            }
        </li>
    );
}